import $ from "jquery";
class SmsReport {
  constructor(loading) {
    this.loading = loading;
    this.username = "vascojonas";
    this.password = "V.Mabui@usendit";

    this.events()
  }


  events(){
    if(document.getElementById("test-sms")){
        let test =document.getElementById("test-sms");  
        test.addEventListener("click", this.testMessage.bind(this));
    }

    if(document.getElementById("test-api")){
        let test =document.getElementById("test-api");  
        test.addEventListener("click", this.sendMessage.bind(this));
    }

    if(document.getElementById("test-excel")){
        let test =document.getElementById("test-excel");  
        test.addEventListener("click", this.exportExcel.bind(this));
    }

    if(document.getElementById("importar-beneficiarios")){
        let importar =document.getElementById("importar-beneficiarios");  
        importar.addEventListener("click", this.importarBeneficiartios.bind(this));
    }
  }

  testMessage(){
   
    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/sms/v1/send",
      method: "POST",
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
     
      success: (response) => {
        console.log(response);        
      },
      error:  error => {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }

  sendMessage( ) {



    let message= "Testando API"
    let number = "258846078485"

    
    
    let sendItUrl = `https://apitest.usendit.co.mz/v2/remoteusendit.asmx/SendMessage?username=${this.username}&password=${this.password}&partnerEventId=&timezone=&partnerMsgId=&sender=uSendit&msisdn=${number}&mobileOperator=-1&priority=0&expirationDatetime=&messageText=${message}&scheduleDatetime=&beginTime=&endTime=&workingDays=false&isFlash=false`;

    
        fetch(sendItUrl)
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
        })
        .catch((error) => {
          // Handle any errors that occur during the API request
          console.log("Error fetching country data:", error);
        });
    
    
  }

  exportExcel(){
    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/excel/v1/export",
      method: "POST",
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
     
      success: (response) => {
        console.log(response);

        let link = document.createElement('a');
        link.href = maisempregoData.root_url+'/wp-content/uploads/cv/'+ response.data.filename;
        link.target="_blank"

        console.log(link)
        link.click();

        
      },
      error:  error => {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }


  importarBeneficiartios(){
    this.loading.showLoadingAnimation();

    let formData = new FormData();
    let beneficiariosInput = document.getElementById("beneficiarios");
    let beneficiarios = beneficiariosInput.files[0];

    formData.append("beneficiarios", beneficiarios);

    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/candidatos/v1/importar",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
     
      success: (response) => {
        console.log(response);


        this.loading.hideLoadingAnimation()
        
      },
      error:  error => {
        console.log(error);
        this.loading.hideLoadingAnimation()
      },
    });


  }
}

export default SmsReport;
